import { GET_REGULATORY_GATEWAY, GET_ALL_GATEWAYS } from '../../types'

const INITIAL_STATE = {
  getAllRegulatorys: [],    
  getAllGateway:[]
}

const regulatoryGateWay = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_REGULATORY_GATEWAY:
      return {
        ...state,
        getAllRegulatorys: payload.data,
        loader: false,
      }

    case GET_ALL_GATEWAYS:
      return {
        ...state,
        getAllGateway: payload.data,
      }
    default:
      return state
  }
}

export default regulatoryGateWay
